<script setup lang="ts">
import type { colorTag } from "@/Modules/App/Models/Styles/Colors";

import ChevronRightIcon from "@/Components/Icons/ChevronRight.vue";

export interface TcMenuItemProps {
  label: string;
  badge?: number;
  iconColor?: colorTag;
}

const props = withDefaults(defineProps<TcMenuItemProps>(), {
  iconColor: "content-high",
});
</script>

<template>
  <li class="menu-item">
    <p class="text">{{ props.label }}</p>
    <span class="badge" v-if="props.badge">{{ props.badge }}</span>
    <ChevronRightIcon :color="props.iconColor" size="sm" :class="props.iconColor" />
  </li>
</template>

<style lang="scss" scoped>
.menu-item {
  @include sp.padding(false, 4);
  @include border(1, solid, b);
  @include colors.border(primary, low);

  height: $size-menu-item-height;
  padding-left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .text {
    @include text.general(low, l);
    @include colors.color(content, high);
  }
}

.badge {
  @include colors.bg(content, mid);
  @include colors.color(content, inverse);

  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  flex: none;
  font-size: 0.7em;
  height: 18px;
  justify-content: center;
  line-height: 5px;
  margin-left: auto;
  margin-right: 10px;
  width: 18px;
}
</style>
